export default __webpack_public_path__ + "static/media/Jessica_productions.bc730476.png";